const wordPattern = new RegExp(['[A-Z][a-z]+', '[A-Z]+(?=[A-Z][a-z])', '[A-Z]+', '[a-z]+', '[0-9]+'].join('|'), 'g');

const words = (string = '', pattern) => (pattern === undefined ? string.match(wordPattern) || [] : string.match(pattern) || []);

const snakeCase = (string = '') =>
  words(string)
    .map(word => word.toLowerCase())
    .join('_');

const isArray = a => Array.isArray(a);

const isObject = o => o === Object(o) && !isArray(o) && typeof o !== 'function';

const camelToSnake = o => {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach(k => {
      n[snakeCase(k)] = camelToSnake(o[k]);
    });

    return n;
  }
  if (isArray(o)) {
    return o.map(i => camelToSnake(i));
  }
  return o;
};

export default camelToSnake;
